const GET_MARKET_BY_REGION = 'GET_MARKET_BY_REGION';
const SET_MARKET_BY_REGION = 'SET_MARKET_BY_REGION';

export {
    GET_MARKET_BY_REGION,
    SET_MARKET_BY_REGION
};